<div class="container transition" [ngClass]="{'text-ltr':!languagesService.isRightToLeft,'text-rtl':languagesService.isRightToLeft}">
    <form [formGroup]="form"  class="form form-register" novalidate>
        

        <div class="row">
            <div class="col-md-1 col-xs-0">

            </div>
            <div class="col-md-10 col-xs-12">
                <div class="row">
                    <div class="col-md-12 col-xs-12 page-title controls-group">
                        <div class="title"><h2>טופס הרשמה</h2></div>
                        <!-- <div class="sign-in"><h5><a routerLink="/login">כניסה לרשומים</a></h5></div><br> -->
                        <hr>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-xs-12" *ngIf="!isFinishedSuccessfuly">
                        <div class="row" *ngIf="baseService.errMessage != ''">
                            <div class="col-md-12 col-xs-12">
                                <span class="colorred">{{baseService.errMessage}} </span>
                            </div>
                        </div>
                        <div class="row" *ngIf="(baseService.errMessage == '') && (baseService.invalidTabName != '')">
                            <div class="col-md-12 col-xs-12">
                                <span class="colorred">בדוק שגיאות ב{{baseService.invalidTabName|replace: 'br>' :' ' | replace: ' < ' :' '}}
                                </span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-xs-12">
                                <app-tabs [Tabs]="Tabs" (activTabChanged)="activTabChanged()" (theLatestTab)="finish()"></app-tabs>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-xs-12 groups">
                                <head-family [form]="f.form_HeadFamilyData" (showTab)="ShowTab($event)" 
                                    (activateMe)="activateTab(0)">
                                </head-family>
                            
                                <partner-data [form]="form" (activateMe)="activateTab(1)"></partner-data>                   
                            
                                <children-data [form]="f.form_ChildrenUp18Data" (activateMe)="activateTab(2)"
                                    [numberOfChildren]="isSubmited ? children_up18_number : 0">
                                </children-data>

                                <div class="col-md-12 col-xs-12">
                                    <declaration-signature [form]="form" [showCaptcha]="showCaptcha" (onreset)="onReset()" (onsubmit)="onSubmit()"></declaration-signature>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>        
        </div>
    </form>
    <app-popup-box [message]="message" [title]="msgBoxTitle" (closed)="message=''" [isError]="isError"></app-popup-box>
</div>
